import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgShare = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.375 8.875H17.625C17.9565 8.875 18.2745 9.0067 18.5089 9.24112C18.7433 9.47554 18.875 9.79348 18.875 10.125V20.125C18.875 20.4565 18.7433 20.7745 18.5089 21.0089C18.2745 21.2433 17.9565 21.375 17.625 21.375H6.375C6.04348 21.375 5.72554 21.2433 5.49112 21.0089C5.2567 20.7745 5.125 20.4565 5.125 20.125V10.125C5.125 9.79348 5.2567 9.47554 5.49112 9.24112C5.72554 9.0067 6.04348 8.875 6.375 8.875H7.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 2.625V11.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 5.75L12 2.625L15.125 5.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgShare.displayName = 'SvgShare';
export default SvgShare;
